export default "__VITE_ASSET__7cb129b2__"